export default __webpack_public_path__ + "static/37982-07d2af4afa8d904dcca8aaa52cb71786.jpg";